import { useSelector, useDispatch } from "react-redux";
import { setSelectedProjectId } from "../../actions/companies";

export default function useSelectedProjectId() {
  const selectedProjectId = useSelector(state => state.companies.selectedProjectId || 0);
  const dispatch = useDispatch();

  const onProjectChange = (projectId) => {
    dispatch(setSelectedProjectId(projectId));
  };

  return [selectedProjectId, onProjectChange];
}
